import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BookingPage } from "./components/atomic-crm/meetings/BookingPage";
import { BOOKING_PATH_PREFIX } from "./components/atomic-crm/meetings/bookingApi";

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// See https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", () => {
  const key = "chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

// Public booking pages (/meeting/<handle>) are for visitors, not CRM users:
// they skip the workspace/auth bootstrap entirely.
const isBookingPage = window.location.pathname.startsWith(BOOKING_PATH_PREFIX);

createRoot(document.getElementById("root")!).render(
  <StrictMode>{isBookingPage ? <BookingPage /> : <App />}</StrictMode>,
);
